import { combineReducers, configureStore } from '@reduxjs/toolkit';

import userReducer from './user/reducer';
import loadingReducer from './loading/reducer';
import pageReducer from './page/reducer';
import { apiSlice } from './api';
import themeReducer from './theme/index';
import mobileMenuReducer from './mobileMenu/index';

const rootReducer = combineReducers({
    user: userReducer,
    loading: loadingReducer,
    page: pageReducer,
    theme: themeReducer,
    mobileMenu: mobileMenuReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export * from './types';
